// useDetectMobile returns whether the current device is mobile or not

const useDetectMobile = (): boolean => {
  // validating through regex for get the device is mobile
  return !!/Android|webOS|iPhone|iPod|BlackBerry|IEMobile/i.test(navigator.userAgent);
};

export default useDetectMobile;
